import { Button } from "@components/atoms";
import { useUserInfo } from "@store/hooks";
import { Colors } from "@utils";
import {
  AuthTutorialLink,
  NationalDataAuthTypeIcon,
  NationalDataAuthTypeKRStr,
} from "@utils/Constants";
import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Divider = styled.div`
  height: 8px;
  background: #f5f5f5;
`;

const DescContainer = styled.div`
  margin-left: 5px;
  border-left: 2px solid #5addc5;
  padding: 17px;
`;

const AuthTutorialPage: React.FC = () => {
  const userInfo = useUserInfo();

  const authType = userInfo.authType!;

  const navigate = useNavigate();

  const gotoNext = () => {
    navigate("/auth");
  };

  return (
    <div className="flex flex-col min-h-full">
      <div className="px-[30px] pt-[40px] pb-[38px]">
        <img
          src={NationalDataAuthTypeIcon.Large[authType]}
          className="w-[48px] h-[48px] mb-[25px]"
          alt=""
        />
        <div
          className="whitespace-pre-wrap text-[20px]/[30px] font-[600]"
          style={{
            color: Colors.totallyBlack,
          }}
        >
          {NationalDataAuthTypeKRStr[authType]} 인증서가 있으신가요?{"\n"}
          있으시면 아래 [다음]을 눌러주세요.
        </div>
      </div>
      <Divider />
      <div className="flex flex-col grow px-[22px] pt-[35px] pb-[22px]">
        <DescContainer>
          <div
            className="text-[17px]/[25px] font-[600] whitespace-pre-wrap"
            style={{
              color: Colors.darkGray,
            }}
          >
            인증서가 없으시면 발급을 도와드릴게요!{"\n"}
            <a
              href={AuthTutorialLink[authType]}
              target="_blank"
              style={{
                color: "#08BA9A",
              }}
              rel="noreferrer"
            >
              [여기]
            </a>
            를 눌러 {NationalDataAuthTypeKRStr[authType]} 인증서를 {"\n"}
            발급받아주세요.
          </div>
        </DescContainer>
        <div className="grow" />
        <Button
          className="mt-[20px]"
          bgColor={Colors.primaryGreen}
          color={Colors.white}
          onClick={gotoNext}
        >
          다음
        </Button>
      </div>
    </div>
  );
};

export default AuthTutorialPage;
